import { ViewStyle } from 'react-native';
import { GradientTokens } from '../../../../theme/index.types';

export const applyGradientStyles = (
  style: ViewStyle,
  gradient: GradientTokens,
) => ({
  ...style,
  background: `var(--${gradient})`,
});
